'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'gamepad-modern';
var width = 576;
var height = 512;
var aliases = [127918,63676,"gamepad-alt"];
var unicode = 'e5a2';
var svgPathData = 'M576 153.4l0 326.6-171.5 0-3.7-10.9-28.3-85.1-168.9 0-28.3 85.1-3.7 10.9-171.5 0 0-326.6 121.4-121.4 333.2 0 121.4 121.4zM32 166.6l0 281.4 116.5 0 28.3-85.1 3.7-10.9 215.1 0 3.7 10.9 28.3 85.1 116.5 0 0-281.4-102.6-102.6-306.8 0-102.6 102.6zM176 208l48 0 0 32-48 0 0 48-32 0 0-48-48 0 0-32 48 0 0-48 32 0 0 48zm208 72a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm48-80a24 24 0 1 1 0-48 24 24 0 1 1 0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGamepadModern = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;